function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.date.to-json.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export function shallowCopyObjectTo(from, to) {
  if (!from) return;
  for (var k in from) {
    to[k] = from[k];
  }
}
export function isEmptyObject(obj) {
  return !obj || !Object.keys(obj).length;
}
/**
 * Makes the deep copy of the input object.
 * For performance purposes, if the values of the properties of the object to copy are all primitive types then we will use the spread operator (faster).
 * Otherwise, to ensure the deep copy of nested objects and arrays, we will use JSON.parse and JSON.stringify (slower).
 * */
export function deepCopy(objToCopy) {
  if (!objToCopy) return null;
  for (var key in objToCopy) {
    var prop = objToCopy[key];
    if (!prop) continue;
    //Sebastian R.S: If the property value is a primitive type, then we will continue!
    if (Array.isArray(prop) || Object.keys(prop).length > 0) {
      return JSON.parse(JSON.stringify(objToCopy));
    }
  }
  return Object.assign({}, objToCopy);
}
export var insertEntry = function insertEntry(obj, k, v) {
  if (!obj) obj = _defineProperty({}, k, v);else obj[k] = v;
};
export var getOrNull = function getOrNull(v) {
  return v ? v : null;
};